import Styles from "./CheckBox.module.css";

export default function Checkbox(props) {
  console.log(props, "checkboxData");

  const { checkboxData, Name, Id, filterData, handleCallApi } = props;

  return (
    <div>
      <div
        className={Styles.checkboxContainer}
        style={{ maxHeight: "250px", overflow: "scroll" }}
      >
        {checkboxData?.map((val, index) => (
          <div
            key={index}
            onClick={(e) => {
              if (props?.disabled) {
                e.preventDefault();
              } else {
                handleCallApi?.(val?.[Id]);
              }
            }}
            className={Styles.checkbox + " form-check mt-3"}
          >
            <input
              className={Styles.input + " form-check-input"}
              type="checkbox"
              value={val?.[Id]}
              id="flexCheckDefault"
              checked={filterData?.includes(val?.[Id])}
              onChange={(e) => {
                if (props?.disabled) {
                  e.preventDefault();
                } else {
                  handleCallApi?.(val?.[Id]);
                }
              }}
              disabled={props?.disabled}
            />
            <p className={Styles.valueText}>{val?.[Name]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
